import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    computed,
    Input,
    inject,
    AfterViewInit,
} from '@angular/core';
import { IOnboardingViewerItem } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';
import { IItemsListAction2 } from '@fi-app/shared/fi-items-list/fi-items-list';
import { FiOnboardingActionsBuilderService } from '../fi-onboarding-actions-builder.service';
import { ObjectTypes, SideListOptionType } from '@fi-app/shared/types';
import { FiOnboardingBuilderStoreService } from '../fi-onboarding-builder-store.service';
import { isNullOrUndefined } from '@fi-app/shared/utils/is-null-or-undefined';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-onboarding-viewer',
    templateUrl: './fi-onboarding-viewer.component.html',
    styleUrls: ['./fi-onboarding-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: { class: 'fi-onboarding-viewer' },
})
export class FiOnboardingViewerComponent implements AfterViewInit {
    @Input({ required: true }) onboardingViewer: IOnboardingViewerItem;
    @Input() stepElementObjectIds: number[] = [];
    @Input() stepElementObjectTypes: ObjectTypes[] = [];

    private readonly fiOnboardingActionsBuilderService = inject(FiOnboardingActionsBuilderService);
    private readonly fiOnboardingBuilderStoreService = inject(FiOnboardingBuilderStoreService);
    private readonly fiStateService = inject(FiStateService);

    protected actions: IItemsListAction2<IOnboardingViewerItem>[] =
        this.fiOnboardingActionsBuilderService.getOnboardingActions<IOnboardingViewerItem>({
            stepElementObjectIds: this.stepElementObjectIds,
            stepElementObjectTypes: this.stepElementObjectTypes,
            onOnboardingDeletedFn: () =>
                this.fiStateService.go(FiStateNames.Onboarding.List, { filterType: SideListOptionType.SharedWithMe }),
        });

    public ngAfterViewInit(): void {
        this.scrollToHighlightedStep();
    }

    private scrollToHighlightedStep(): void {
        const highlightedStepElementId = this.fiOnboardingBuilderStoreService.highlightedStepElementId();
        if (!highlightedStepElementId) {
            return;
        }

        const elementToScrollTo = document.getElementById(highlightedStepElementId);
        if (isNullOrUndefined(elementToScrollTo)) {
            console.warn(`'Element to scroll to (stepElementId: ${highlightedStepElementId}) not found'`);
            return;
        }

        const container = document.querySelector('.fi-content');
        const containerRect = container.getBoundingClientRect();
        const targetRect = elementToScrollTo.getBoundingClientRect();

        container.scrollTo({
            top: container.scrollTop + (targetRect.top - containerRect.top),
            behavior: 'smooth',
        });
    }

    protected back(): void {
        window.history.back();
    }
}
